//import React components
import PropTypes from "prop-types";


//import components


PageContainer.propTypes = {
    children: PropTypes.any.isRequired
}

PageContainer.defaultProps = {

}

export default function PageContainer ({...props}) {
    return (
        <>
            <div>
                {props.children}
            </div>
        </>
    )
}
